module.exports = __webpack_public_path__ + "static/img/articleAI1.acd7e06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articleAI1.jpg
// module id = vHV5
// module chunks = 1